module.exports = __webpack_public_path__ + "static/media/32159_lower.1e8eacd2.jpg";